import React, { useCallback, useEffect, useRef, useState, useContext } from "react";
import { LoginSocialGoogle } from "reactjs-social-login";
import { GoogleLoginButton } from "react-social-login-buttons";
import Layout from "../layouts/Layout";
import UserRegister from '../components/UserPages/UserRegister';
import { useUserContext } from "../store/user_context";
import Cookies from "js-cookie";
import { sendRequest } from "../hooks/fetchData";
import { useNavigate } from 'react-router-dom';

const Social_login = () => {
    const REDIRECT_URI = "http://localhost:5173/dwqdwqwqdwqd";
    const apiUrl = import.meta.env.VITE_API_URL;
    const login = import.meta.env.VITE_login;
    const google_client_id = import.meta.env.VITE_google_client_id;

    const { user, setUser } = useUserContext();
    const googleRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        try {
            const userDateSerialized = Cookies.get('user_data');
            if (userDateSerialized) {
                setUser(JSON.parse(userDateSerialized));
            }
        } catch (error) {
            console.error('Error parsing user data from cookies:', error);
        }
    }, [setUser]);

    const [registerData, setRegisterData] = useState(null);

    useEffect(() => {
        // when user becomes available, clear any registerData so Layout can render
        if (user) setRegisterData(null);
    }, [user]);

    const handleLoginSuccess = useCallback(async ({ provider, data }) => {
        if (data?.email) {
            try {
                const fetchedUser = await loginUser(data.email);
                if (fetchedUser) {
                    setUser(fetchedUser);
                    Cookies.set('user_data', JSON.stringify(fetchedUser));
                } else {
                    // No user on backend — show registration form with prefilled data
                    setRegisterData({ email: data.email, name: data.name });
                }
            } catch (err) {
                console.error('Failed to fetch user by email:', err);
            }
        }
    }, [setUser]);



     const loginUser = async (email) => {
        const url = `${apiUrl}${login}`;
        const { done, isError, data } = await sendRequest(url, 'POST', { Email: email });

        if (done && !isError && data?.user) {
            Cookies.set('auth_token', data.token, { secure: true,  expires: 7   });
            return data.user;
        }
        return null;
    };


    return (
        <>
            {registerData ? (
                <UserRegister initialData={registerData} />
            ) : !user ? (
                <div className="App box">
                    <div className="logo">
                        <img src="/images/google.jpg" alt="Google Logo" />
                    </div>
                    <h2>Sign In</h2>
                    <p>Use your Google Account</p>
                    <LoginSocialGoogle
                        ref={googleRef}
                        scope="openid profile email"
                        client_id={google_client_id}
                        redirect_uri={REDIRECT_URI}
                        onResolve={handleLoginSuccess}
                        onReject={(err) => {
                            console.error(err);
                        }}
                    >
                        <GoogleLoginButton />
                    </LoginSocialGoogle>
                </div>
            ) : (
                <Layout />
            )}
        </>
    );
};

export default Social_login;